function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { string, arrayOf, number } from 'prop-types';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import { barStyles, gridLinesStyles, labelStyles, tooltipStyles, labelTextStyles, MAX_LABEL_SIZE } from './BarChart.styles';
export const BarChart = _ref => {
  let {
    labels,
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(Bar, {
    data: () => {
      return {
        labels,
        datasets: [_objectSpread(_objectSpread({}, barStyles), {}, {
          data
        })]
      };
    },
    plugins: [ChartDataLabels],
    options: {
      indexAxis: 'y',
      maintainAspectRatio: false,
      scales: {
        yAxis: {
          ticks: {
            display: false
          },
          grid: {
            drawBorder: false,
            display: false
          }
        },
        xAxis: {
          ticks: {
            callback: value => value % 1 === 0 ? value : undefined
          },
          gridLines: gridLinesStyles
        }
      },
      plugins: {
        tooltip: _objectSpread(_objectSpread({}, tooltipStyles), {}, {
          callbacks: {
            label: _ref2 => {
              let {
                label,
                raw
              } = _ref2;
              return "".concat(label, ": ").concat(raw, " Activities");
            },
            title: () => null
          }
        }),
        legend: {
          display: false
        },
        gridLines: {
          display: true
        },
        datalabels: _objectSpread(_objectSpread({}, labelStyles), {}, {
          formatter: (_, context) => {
            const label = labels[context.dataIndex];
            return "".concat(label.substring(0, MAX_LABEL_SIZE)).concat(label.length > MAX_LABEL_SIZE ? '...' : '');
          },
          font: labelTextStyles
        })
      }
    }
  });
};
BarChart.propTypes = {
  labels: arrayOf(string).isRequired,
  data: arrayOf(number).isRequired
};
BarChart.defaultProps = {};